import { render, staticRenderFns } from "./certificateValidationQuestions.vue?vue&type=template&id=3210520e&scoped=true&"
import script from "./certificateValidationQuestions.vue?vue&type=script&lang=js&"
export * from "./certificateValidationQuestions.vue?vue&type=script&lang=js&"
import style0 from "./certificateValidationQuestions.vue?vue&type=style&index=0&id=3210520e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3210520e",
  null
  
)

export default component.exports